import WithRender from "../../templates/tables/optionsTable.html";

export default WithRender({
  computed: {
    name: () => {
      return "Options";
    }
  }
});
